import React, { useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { LanguageCode, useTranslationContext } from '@pegasus/translation';
import { HeaderWithSignUp } from '@pegasus/ui-headers';
import { useConfig } from 'src/client/hoc/config';
import { UserHeader } from './user-header';

type OwnProps = {
    isGuest?: boolean;
};

export const _HeaderWrapper = ({ location, isGuest = true }: OwnProps & RouteComponentProps) => {
    const config = useConfig();
    const { translations } = useTranslationContext();

    const languageSwitcherConfig = (config.languages || []).map(language => {
        return {
            ...language,
            url: `${language.url}${location.pathname}`,
        };
    });

    const [isLoginCta, setIsLoginCta] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(() => {
        if (location.hash.includes('/login') || location.hash.includes('/register')) {
            return true;
        }
        return false;
    });

    const showModal = () => {
        setIsLoginCta(!isLoginCta);
        setIsModalOpen(true);
        window.__ONBOARDING_FORMS.show(isLoginCta ? '/login' : '/register');
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setIsLoginCta(false);
        window.__ONBOARDING_FORMS.hide('/');
    };

    return (
        <>
            {isGuest ? (
                <HeaderWithSignUp
                    translations={translations}
                    languageCode={translations.locale as LanguageCode}
                    supportedLanguages={languageSwitcherConfig}
                    isPrive={config.isPrive}
                    isWithSignUp={true}
                    showModal={showModal}
                    handleClose={handleClose}
                    isLoginCta={isLoginCta}
                    isModalOpen={isModalOpen}
                />
            ) : (
                <UserHeader
                    translations={translations}
                    supportedLanguages={languageSwitcherConfig}
                />
            )}
        </>
    );
};

export const HeaderWrapper: React.ComponentClass<OwnProps> = withRouter(React.memo(_HeaderWrapper));
